import React from 'react';
import { Popconfirm, message, Popover } from 'antd';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import { EditManHour, MyHourDetail } from './Widget';
import { DetailRecord, TotalRecord } from './Filter';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import '../../execute/style/list.less';
import SideNav from '../SideNav';
import moment from 'moment';

const MonthFormat = 'YYYY-MM';

class Hour extends React.Component {
    state = {
        loading: false,
        type: 'detail',
        searchParams: {
            startDate: `${moment().add(-1, 'M').format(MonthFormat)}-26`,
            endDate: `${moment().format(MonthFormat)}-25`,
        },
        dataList: [],
        businessList: [],
        pagination: {
            pageSize: 10,
            current: 1,
        },
        currentDate: '', //当前日期
    }

    componentDidMount() {
        if ((location.href.indexOf('investigation') > -1) || (location.href.indexOf('daily') > -1)) {
            this.btnChangeType('total');
        } else {
            this.loadData();
        }
        this.queryWithLevelByParams();
        this.getDate();
    }

    // 获取系统时间
    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({ currentDate: date });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { type, searchParams = {}, pagination } = this.state;
        let url = type == 'detail' ? API_URL.manhour.queryMyManHourDetail : API_URL.manhour.queryUserHourSummary;
        const options = {
            method: 'POST',
            url,
            data: {
                ...searchParams,
                limit: 10,
                offset: pagination.current,
            },
            dataType: 'json',
            doneResult: (res => {
                let ct = Number((res.totalCount / (pagination.pageSize - 1)).toFixed(0)) + (res.totalCount % (pagination.pageSize - 1) > 0 ? 1 : 0);
                pagination.total = res.totalCount + ct;
                pagination.pageSize = 11;
                this.setState({
                    loading: false,
                    dataList: res.datas ? res.datas : [],
                    pagination,
                });
            }),
            errorResult: (() => {
                this.setState({ loading: false });
            }),
        };
        $.sendRequest(options);
    }

    search = (param) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: param,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams = {}, pagination, type } = this.state;
        const url = type == 'detail' ? API_URL.manhour.exportMyManHourDetail : API_URL.manhour.exportUserHourSummary;
        ExportUtil.export(searchParams, pagination, url);
    }

    canEditByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    }  else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    }  else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                        message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '工作日期',
        dataIndex: 'manHourDateString',
        key: 'manHourDateString',
        width: 80,
        fixed: 'left',
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
        fixed: 'left',
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 120
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 80,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 80,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return null;
            } else {
                return text;
            }
        },
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 120,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return null;
            } else {
                return text;
            }
        },
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 60,
    }, {
        title: '工作类型',
        dataIndex: 'enterpriseWorkNameValue',
        key: 'enterpriseWorkNameValue',
        width: 100,
    }, {
        title: '工作内容',
        dataIndex: 'enterpriseWorkTypeString',
        key: 'enterpriseWorkTypeString',
        width: 100,
    }, {
        title: '工时(h)',
        dataIndex: 'durationStringNoH',
        key: 'durationStringNoH',
        width: 80,
        render: (text, record) => {
            const obj = { children: text };
            if (record.manHourVisitTip) {
                const list = record.manHourVisitTip.split(';');
                const node = list.map(item => <div>{item}</div>);
                obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                    <div>
                        <i className='pop'></i>
                        {text}
                    </div>
                </Popover>
            }
            // if (record.remarks) {
            //     const len = Math.ceil(record.remarks.length / 10);
            //     const node = [];
            //     for (let i = 0; i < len; i++) {
            //         node.push(<p key={i}>{record.remarks.slice(i * 10, (i + 1) * 10)}</p>);
            //     }
            //     obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
            //         <div>
            //             <i className='pop'></i>
            //             {text}
            //         </div>
            //     </Popover>
            // }
            return obj;
        },
    }, {
        title: '备注',
        dataIndex: 'remarks',
        key: 'remarks',
        width: 80,
    }, {
        title: '状态',
        dataIndex: 'statusName',
        key: 'statusName',
        width: 80,
    }, {
        title: '操作',
        key: 'operation',
        width: 80,
        fixed: 'right',
        render: (text, record) => {
            const { status, manHourId, durationStringNoH, investigationId, remarks } = record;
            return (
                <span>
                    {
                        manHourId > 0 ?
                            status != 'VERIFY' ?
                                <span>
                                    <a onClick={()=>this.canEditByInvStatus(investigationId,() => this.editManHour(manHourId, durationStringNoH,remarks))}>修改</a>
                                    <span className="ant-divider" />
                                    <Popconfirm title='确定删除该工时记录？' onConfirm={()=>this.canEditByInvStatus(investigationId,() => this.delManHour(manHourId))} okText="确定" cancelText="取消">
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                                :
                                <span>
                                    <a disabled={true}>修改</a>
                                    <span className="ant-divider" />
                                    <a disabled={true}>删除</a>
                                </span>
                            :
                            ''
                    }
                </span>
            );
        },
    }]

    getTotalColumns = () => [{
        title: '工作日期',
        dataIndex: 'manHourDateString',
        key: 'manHourDateString',
        width: 100,
        fixed: 'left',
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
        fixed: 'left',
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 140,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 120,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return null;
            } else {
                return text;
            }
        },
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 100,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return null;
            } else {
                return text;
            }
        },
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 80,
    }, {
        title: '工时(h)',
        dataIndex: 'hour',
        key: 'hour',
        width: 100,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return text;
            } else {
                return (<span style={{ color: '#108ee9', cursor: 'pointer' }} onClick={() => this.showMyHourDetail(record)}>{text}</span>);
            }
        }
    }, {
        title: '状态',
        dataIndex: 'statusName',
        key: 'statusName',
        width: 100,
        render: (text, record) => {
            if (record.manHourDateString == '总计') {
                return null;
            } else {
                return text;
            }
        },
    }, {
        title: '操作',
        key: 'operation',
        width: 100,
        fixed: 'right',
        render: (text, record) => {
            const { investigationId  } = record || {};
            return (
                <span>
                    {
                        record.manHourDateString != '总计' ?
                            record.statusName === '待确认(待修改)' ?
                                <span>
                                    <a href="javascript:void(0)" onClick={()=>this.canEditByInvStatus(investigationId,() => this.markModifyComplete(record))}>标记修改完成</a>
                                </span>
                                : '-'
                            :
                            ''
                    }
                </span>
            );
        },
    }]

    getDataSource = () => {
        const dataResult = [];
        const { type, dataList, pagination: { current, pageSize } } = this.state;
        if (dataList[0]) {
            dataList.map((item, i) => {
                let status
                if (item.status == "VERIFY") {
                    status = '已确认';
                } else if (item.memoryStatus != null && item.memoryStatus == "ACTIVE") {
                    status = "待确认(待修改)";
                } else if (item.memoryStatus != null && item.memoryStatus == "INACTIVE") {
                    status = "待确认(已修改)";
                } else if (item.status == "UNVERIFY") {
                    status = '待确认';
                }
                dataResult.push({
                    index: (current - 1) * pageSize + i + 1,
                    ...item,
                    investigationSiteCode: item.investigationSiteCode ? item.investigationSiteCode : '-',
                    investigationSiteName: item.investigationSiteName ? item.investigationSiteName : '-',
                    statusName: status,
                    hour: item.hour ? item.hour.toFixed(2) : '',
                    manHourDateString: type == 'detail' ? item.manHourDateString : (item.hourId === 0 ? '总计' : `${item.yearNum}-${item.monthNum}`)
                });
            });
        }
        return dataResult;
    };

    editManHour = (manHourId, duration, remarks) => {
        this.EditManHourRef.show(manHourId, duration, remarks);
    }

    delManHour = (manHourId) => {
        const options = {
            method: 'POST',
            url: `${API_URL.manhour.delmanhour}`,
            data: { manHourId },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.data.success);
                    this.loadData();
                } else {
                    message.error(res.error);
                }
            })
        }
        $.sendRequest(options)
    }

    showMyHourDetail = (record) => {
        this.MyHourDetailRef.show(record);
    }

    markModifyComplete = (record) => {
        const options = {
            method: 'POST',
            url: `${API_URL.manhour.remarkManHourNoticeModify}`,
            data: {
                hourId: record.hourId,
                hourType: record.hourType,
                investigationSiteUserFteMonthSummaryId: record.investigationSiteUserFteMonthSummaryId,
                userCompellation: record.userCompellation || sessionStorage.userName,
                dateValue: record.manHourDateString,
                investigationId: record.investigationId,
                investigationName: record.investigationName,
                investigationSiteId: record.investigationSiteId,
                investigationSiteName: record.investigationSiteName,
                hourId: record.hourId,
                hourType: record.hourType,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                } else {
                    message.success(res.error);
                }
            })
        }
        $.sendRequest(options)
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    btnChangeType = (type) => {
        const { pagination } = this.state;
        pagination.current = 1;
        const searchParams = {};
        if (type == 'detail') {
            searchParams.startDate = `${moment().add(-1, 'M').format(MonthFormat)}-26`;
            searchParams.endDate = `${moment().format(MonthFormat)}-25`;
        } else {
            searchParams.startDate = moment().format(MonthFormat);
            searchParams.endDate = moment().format(MonthFormat);
        }
        this.setState({
            type,
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination, type, businessList, currentDate } = this.state;
        const scrollY = document.documentElement.clientHeight - 200;
        return (
            <div className="content">
                <SideNav selectKey='myHour' />
                <div className="main home">
                    <div className='change-btn' style={{ marginBottom: 10 }}>
                        <a onClick={this.btnChangeType.bind(this, 'detail')} className={type == 'detail' ? 'cur' : ''} >明细记录</a>
                        <a onClick={this.btnChangeType.bind(this, 'total')} className={type == 'total' ? 'cur' : ''} >汇总记录</a>
                    </div>
                    {
                        type == 'detail' ? <DetailRecord 
                            businessList={businessList} 
                            search={this.search} 
                            export={this.export} 
                            chooseType={this.state.type}
                            currentDate={currentDate} 
                        /> :
                        <TotalRecord 
                            businessList={businessList} 
                            search={this.search} 
                            export={this.export} 
                            MyHourParams={this.props.match.params} chooseType={this.state.type} 
                            currentDate={currentDate} 
                        />
                    }
                    <TableC
                        columns={type == 'detail' ? this.getColumns() : this.getTotalColumns()}
                        data={this.getDataSource()}
                        rowKey='manHourId'
                        loading={loading}
                        scrollY={scrollY}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
                <MyHourDetail ref={el => this.MyHourDetailRef = el} />
                <EditManHour ref={el => this.EditManHourRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Hour;



// WEBPACK FOOTER //
// ./src/components/manHour/hour/index.js